'use es6';

export const AND = 'and';
export const OR = 'or';
export const NOT = 'not';